import * as yup from 'yup';

export const factoryLineSchema = yup.object().shape({
    name: yup
        .string()
        .trim()
        .required(),
});

export const factorySchema = yup.object().shape({
    name: yup
        .string()
        .trim()
        .required(),
    countryCode: yup
        .string()
        .trim()
        .required(),
    address: yup
        .string()
        .trim()
        .required(),
    factoryLines: yup
        .array()
        .of(factoryLineSchema)
        .min(1),
});

export const factoryEditSchema = yup.object().shape({
    name: yup
        .string()
        .trim()
        .required(),
    address: yup
        .string()
        .trim()
        .required(),
    factoryLines: yup
        .array()
        .of(factoryLineSchema)
        .min(1),
});

export const factoriesSchema = yup.object().shape({
    factories: yup
        .array()
        .of(factorySchema)
        .min(1),
});
